export default "__VITE_ASSET__8d68ff36__"